import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-upload-info',
  templateUrl: './file-upload-info.component.html',
  styleUrls: ['./file-upload-info.component.scss'],
})
export class FileUploadInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
